import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {tap} from 'rxjs';
import {Router} from '@angular/router';
import {EditActions} from '../actions/edit.actions';
import {map} from 'rxjs/operators';
import {NavigationService} from '@adnova/jf-ng-components';

@Injectable()
export class EditEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private navigationService: NavigationService,
  ) {}

  readonly openEdit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EditActions.openEdit),
      tap(action => {
        this.router.navigate(['/edit/inhaber/' + action.inhaberId + '/beleg/' + action.belegId]);
      }),
      map(action => EditActions.openEditSuccess({belegIds: action.belegIds})),
    ),
  );

  readonly openOverviewPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EditActions.openOverviewPage),
      map(() => {
        const inhaberId = this.navigationService.currentInhaber?.id;
        this.router.navigate(['/overview/inhaber/' + inhaberId]);

        return EditActions.openOverviewPageSuccess();
      }),
    ),
  );
}
